import { useEffect, useState } from "react";
import axios from "axios";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function MsaDownloadButton() {
  const { authHeader, apiBase } = useAuth();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${apiBase}/vendor/msa/info`, {
          headers: authHeader(),
        });
        setInfo(data);
      } catch {
        setInfo({ has_msa: false });
      }
    })();
  }, [apiBase, authHeader]);

  if (!info || !info.has_msa) return null;

  const download = async () => {
    setBusy(true);
    try {
      const res = await axios.get(`${apiBase}/vendor/msa`, {
        headers: authHeader(),
        responseType: "blob",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${info.reference || "MSA"}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("MSA downloaded.");
    } catch {
      toast.error("MSA download failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={download}
      disabled={busy}
      data-testid="vendor-msa-download"
      className="inline-flex items-center gap-2 border border-white/15 hover:border-red-500 text-white text-xs font-medium px-4 py-2 rounded-sm transition-colors disabled:opacity-70"
    >
      {busy ? <Loader2 size={14} className="animate-spin" /> : <FileDown size={14} />}
      MSA · {info.reference}
    </button>
  );
}
